function format(n: number, maximumFractionDigits?: number) {
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits,
  }).format(n);
}

export const NumberFormatter = {
  format,
};
